/* Const,Let & Var will be here */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const USER_ROLE_TYPE = 'UserRoleType';
export const COMPANY_PARTYROLE = 'CompanyPartyRole';
export const DeliveryAgent = 'DeliveryAgent';
export const APPROVALMANAGER = 'ApprovalManager';
export const DEVELOPER = 'Developer';
export const EXECUTIVE = 'EXECUTIVE';
export const DELIVERY_EXECUTIVE = 'DeliveryExecutive';
export const CUSTOMER = 'Customer';
export const LOGOUT = 'Logout';
export const VENDOR = 'Vendor';
/* Const,Let & Var will be here */

export function login(isLoginSuccess, firstName, lastName, fullName, email, phoneNumber, accessToken, userName, userId, roleId, roleName, claimValue) {
    if (isLoginSuccess) {
        return {
            type: LOGIN_SUCCESS,
            firstName: firstName,
            lastName: lastName,
            fullName: fullName,
            email: email,
            phoneNumber: phoneNumber,
            accessToken: accessToken,
            userName: userName,
            userId: userId,
            roleId: roleId,
            roleName: roleName,
            claimValue: claimValue
        };
    } else {
        return {
            type: LOGIN_ERROR
        };
    }
}

export function logout() {
    return {
        type: LOGOUT
    };
}

export function userRole(roleType) {
    return {
        type: USER_ROLE_TYPE,
        userRole: roleType
    };
}

export function updateCompanyRole(companyRoleId) {
    return {
        type: COMPANY_PARTYROLE,
        companyRoleId: companyRoleId
    };
}